import { Button } from 'components-antd';

import styles from './styles.module.scss';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { routes } from 'settings/navigation/routes';

export const CopyFormButton = (props) => {
  const history = useHistory();
  const { formDetails, selectedFormProcess, disableSections } = props;

  const onMakeFormCopy = () => {
    history.push({
      pathname: routes.workshopFormProcessRequest,
      state: {
        voidedForm: false,
        createFormCopy: true,
        formDetails,
        name: formDetails?.formName,
        formProcessId: selectedFormProcess,
      },
    });
  };

  return (
    <div className={styles.buttonWrapper}>
      <Button
        variant="default"
        className={classNames(styles.formCopyButton, { [styles.disabledSection]: disableSections })}
        onClick={onMakeFormCopy}
        disabled={disableSections}
      >
        <div className={styles.formCopyButtonContainer}>Copy</div>
      </Button>
    </div>
  );
};
